const HEADER_FILL = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E3A5F" } };
const TOTAL_FILL = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF1F5F9" } };
const BORDER = { top: { style: "thin", color: { argb: "FFCBD5E1" } }, left: { style: "thin", color: { argb: "FFCBD5E1" } }, bottom: { style: "thin", color: { argb: "FFCBD5E1" } }, right: { style: "thin", color: { argb: "FFCBD5E1" } } };

// columns: [{ header, key, width, numFmt?, total? }]
export const exportToXlsx = async ({ fileName, title, subtitle, sheetName, columns, rows }) => {
  const ExcelJS = (await import("exceljs")).default;
  const wb = new ExcelJS.Workbook();
  wb.creator = "KPM Infrastructure";
  const ws = wb.addWorksheet(sheetName || "Report");
  const lastCol = String.fromCharCode(64 + columns.length);

  ws.mergeCells(`A1:${lastCol}1`);
  ws.getCell("A1").value = "KPM INFRASTRUCTURE PRIVATE LIMITED";
  ws.getCell("A1").font = { bold: true, size: 14, color: { argb: "FF1E3A5F" } };
  ws.mergeCells(`A2:${lastCol}2`);
  ws.getCell("A2").value = title;
  ws.getCell("A2").font = { bold: true, size: 12 };
  ws.mergeCells(`A3:${lastCol}3`);
  ws.getCell("A3").value = subtitle;
  ws.getCell("A3").font = { italic: true, size: 10, color: { argb: "FF475569" } };

  const headerRow = ws.getRow(5);
  columns.forEach((c, i) => {
    const cell = headerRow.getCell(i + 1);
    cell.value = c.header;
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = HEADER_FILL;
    cell.border = BORDER;
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    ws.getColumn(i + 1).width = c.width || 14;
  });
  headerRow.height = 22;

  rows.forEach((r, idx) => {
    const row = ws.getRow(6 + idx);
    columns.forEach((c, i) => {
      const cell = row.getCell(i + 1);
      cell.value = r[c.key] ?? "";
      cell.border = BORDER;
      if (c.numFmt) cell.numFmt = c.numFmt;
    });
  });

  const totalRow = ws.getRow(6 + rows.length);
  totalRow.getCell(1).value = `TOTAL (${rows.length} entries)`;
  columns.forEach((c, i) => {
    const cell = totalRow.getCell(i + 1);
    if (c.total) {
      cell.value = rows.reduce((s, r) => s + (Number(r[c.key]) || 0), 0);
      if (c.numFmt) cell.numFmt = c.numFmt;
    }
    cell.font = { bold: true };
    cell.fill = TOTAL_FILL;
    cell.border = BORDER;
  });
  ws.views = [{ state: "frozen", ySplit: 5 }];

  const buf = await wb.xlsx.writeBuffer();
  const blob = new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const describeFilters = (filters, { materials, partyLabel }) => {
  const parts = [];
  parts.push(filters.from || filters.to ? `Period: ${filters.from || "start"} to ${filters.to || "today"}` : "Period: All dates");
  if (filters.category && filters.category !== "all") parts.push(`Category: ${filters.category.replace(/_/g, " ")}`);
  if (filters.material_id && filters.material_id !== "all") parts.push(`Material: ${materials.find((m) => m.id === filters.material_id)?.name || ""}`);
  if (filters.party && filters.party !== "all") parts.push(`${partyLabel}: ${filters.party}`);
  if (filters.search) parts.push(`Search: "${filters.search}"`);
  return parts.join("  |  ");
};
